export default "__VITE_ASSET__CICJB9Y$__"